import React from 'react';
import { Portal } from 'react-portal';
import { SimpleTooltip } from '../Tooltip/SimpleTooltip';
import { throttle } from 'lodash';

const setInactive = () => ({
    target: 'labels',
    mutation: () => ({ active: false }),
});

const customEvents = [
    {
        target: 'data',
        eventHandlers: {
            onMouseOver: (evt) => ({
                target: 'labels',
                mutation: () => ({
                    active: true,
                    clientX: evt.clientX,
                    clientY: evt.clientY,
                }),
            }),
            onMouseOut: setInactive,
            onWheel: throttle(setInactive, 2000, { leading: true }),
        },
    },
];

export const ChartTooltip = ({ content, datum, active, clientX, clientY, x, y, tooltipContainerRef, offsetX = 0 }) => {
    const TooltipContent = content;

    if (!active) {
        return null;
    }

    const left = clientX || x;
    const top = clientY || y;
    const hasAbsolutePosition = clientX === undefined;

    return (
        <g>
            <Portal node={tooltipContainerRef ? tooltipContainerRef.current : null}>
                <SimpleTooltip active left={left + offsetX} top={top} hasAbsolutePosition={hasAbsolutePosition}>
                    <TooltipContent data={datum} />
                </SimpleTooltip>
            </Portal>
        </g>
    );
};

ChartTooltip.defaultEvents = customEvents;
